import {
    CreateAccountBodyParams,
    UserResponse,
    UserSignInResponse,
    ArticleSearchResultResponse,
    ArticleFilterQueryParams,
    MainEndpoints,
    CompleteSignupBodyParams
} from "@authory-packages/core";
import axios, { AxiosError } from "axios";
import { API_URL, withUserSlug } from ".";
import { logAxiosError } from "../logging/logSentryError";
import { Errors } from "../types/api";
import { APPLICATION_ROUTES } from "../shared-logic/routes";
import { NotificationHandler } from "./error-handler";
import { getHeaders } from "./get-headers";

export const createAccount = async (credentials: CreateAccountBodyParams) => {
    const { data } = await axios.post<UserSignInResponse>(`${API_URL}${MainEndpoints.SignupCreateAccount}`, credentials);
    return data;
};

export const onCreateAccountError = (toastHandler: NotificationHandler) => async (error: AxiosError) => {
    const Message = () => (
        <span>
            It looks like you've already signed up. You can log in{" "}
            <a style={{ color: "inherit" }} href={APPLICATION_ROUTES.LOGIN}>
                here
            </a>
            .
        </span>
    );

    if (error?.response?.status === Errors.State) {
        toastHandler(<Message />);
    } else if (
        error?.response?.status === Errors.AccessDenied &&
        !!error?.response?.data.message.length &&
        error?.response?.data.message.includes("Turnstile")
    ) {
        toastHandler(<span>Cloudflare captcha validation failed </span>);
    } else if (error?.response?.status === Errors.AccessDenied) {
        toastHandler("Sorry, signing up with your preferred method didn't work. Please sign up via email.");
    } else {
        toastHandler("An unexpected error occured");
        logAxiosError(error);
    }
};

interface SignupSetupUser {
    params: CompleteSignupBodyParams;
    token: string;
}

export const signupSetupUser = async ({ params, token }: SignupSetupUser) => {
    const { data } = await axios.post<UserResponse>(`${API_URL}${MainEndpoints.SignupSetupUser}`, params, getHeaders(token));
    return data;
};

export const getReactivationUserArticles = async (token: string | null, userSlug: string | undefined, params: ArticleFilterQueryParams) => {
    const { data } = await axios.get<ArticleSearchResultResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.ReactivationUserArticles, userSlug || "")}`,
        {
            params,
            ...getHeaders(token || "")
        }
    );

    return data;
};
